import { useCallback } from 'react';

import { useFeatureFlag } from 'context/FeatureFlagContext';

export const COUNTERPARTY_AI_NARRATIVE_FLAG = 'counterpartyAiNarrative';

type TimelineCardRef = { __typename: string };

// The Counterparty Insights card holds only the AI narrative, which stays withheld
// until the grounded regulatory profile replaces it; a missing flag reads as off.
export const useIsTimelineCardShown = (): ((card: TimelineCardRef) => boolean) => {
  const isCounterpartyAiNarrativeEnabled = useFeatureFlag(COUNTERPARTY_AI_NARRATIVE_FLAG);

  return useCallback(
    (card: TimelineCardRef) =>
      card.__typename !== 'CounterpartyInsightsCard' || isCounterpartyAiNarrativeEnabled,
    [isCounterpartyAiNarrativeEnabled],
  );
};
